module.exports = __webpack_public_path__ + "static/kipa-sm-869080fa6e03c5022d57676794ff2509.jpg";